import { cn } from "@dalmatech/ui"

export const dialogContent = cn("z-[60] max-w-[26rem] gap-4 p-8 text-center")

export const drawerContent = cn("z-[60] gap-4 text-center")

export const illustrationWrapper = cn("flex w-full justify-center")

export const title = cn("text-xl font-bold text-neutral-900")

export const description = cn("text-sm text-neutral-600")

export const buttonsWrapper = cn("flex w-full flex-col gap-3 mt-2")

// Custom backdrop — Radix/vaul don't render a visible overlay when modal={false}
// (which we need for Axeptio click-through). pointer-events-none keeps third-party
// elements like the cookie banner clickable on top of the tint.
export const backdrop = cn(
  "fixed inset-0 z-[55] bg-neutral-600/60 pointer-events-none",
  "animate-in fade-in duration-200"
)
